export enum EApiKnownErrors {
  GeneralError = 'generalError',
  Runtime = 'runtime',
}
